import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../../common/withRouter';
import { Image } from "../Facility";
import {
  DataDefinitionList,
  Notification,
  Message,
  ButtonOBSOLETED
} from '../../../web.common';
import withApi from '../../higherOrderComponents/withApi';
import ProductFields from './sections/ProductFields';
import Integration from './sections/Integration';
import { DetailsRightBar, Link, Action, Divider } from '../DetailsRightBar';
import PageTop from '../../layout/PageTop';
import { AvailabilityInfo } from './AvailabilityInfo';
import { PriceRules } from './PriceRules';
import { Relay } from './Relay';
import { Schedule } from './Schedule';
import { CrawlFilters } from "./CrawlFilters";
import { SchemeSelectorHook } from './sections/SchemeSelectorHook';
import {
  DisplayGuid,
  DisplayDate,
  DisplayType,
  DisplayBoolean,
  DisplayCurrencyAmount,
  DisplayPercentage
} from '../../items';
import AsyncSelect from "react-select/async";
import ReactSelect from 'react-select';
import { mappedPriceLevels } from '../../../enums/PriceLevels';
import { descriptionScheme } from "./initializeProductData";
import ImageCropper from '../../misc/ImageCropper.js';
import RichTextEditor from '../../misc/RichTextEditor';
import HtmlContent from '../../misc/HtmlContent';
import ViewSwitch from '../../misc/ViewSwitch';
import IntegratedResourcesBoard from './IntegratedResourcesBoard';
import IntegratedResourcesLayout from './IntegratedResourcesLayout';
import { confirmRemoval } from './integratedResourceChecks';

const INTEGRATED_RESOURCES_VIEWS = [
  { key: 'new', label: 'New view' },
  { key: 'classic', label: 'Classic view' },
  { key: 'layout', label: 'Layout view' }
];


const IntegratedResources = withApi(({ api, productId }) => {
  const [resources, setResources] = useState(null);
  const [showAlert, setShowAlert] = useState(null);
  const [modelNew, setModelNew] = useState(null);
  const [modelEdit, setModelEdit] = useState(null);

  useEffect(() => {
    async function loadFromApi() {
      const loadedResources = await api.integrations.getIntegratedResources(productId);
      setResources(loadedResources);
    }

    if (!resources) {
      loadFromApi();
    }
  });

  if (resources === null) {
    return (
      <React.Fragment>
        Loading...
      </React.Fragment>);
  }

  return (
    <React.Fragment>
      <h3>Integrated Resources</h3>
      <button
        type="button"
        className="button button-color-primary button-shrink-limited"
        onClick={async () => {
          setShowAlert('new');
          setModelNew({
            externalId: '',
            match: '',
            resourceGroupId: ''
          });
        }}>
        New
      </button>

      <br></br>
      <br></br>

      {
        showAlert == 'new' ?
          <React.Fragment>
            <form>
              <label for="ExternalIdInput">ExternalId</label>
              <input id="ExternalIdInput" name="ExternalIdInput"
                value={modelNew.externalId}
                onChange={({ target }) => { setModelNew({ ...modelNew, externalId: target.value }) }} />
              <br />
              <label for="MatchExpression">Match Expression</label>
              <input id="MatchExpression" name="MatchExpression" value={modelNew.match}
                onChange={({ target }) => { setModelNew({ ...modelNew, match: target.value }) }} />
              <br />
              <label for="ResourceGroupId">ResourceGroupId</label>
              <input id="ResourceGroupId" name="ResourceGroupId" value={modelNew.resourceGroupId || ''}
                onChange={({ target }) => { setModelNew({ ...modelNew, resourceGroupId: target.value }) }} />
              <br />
              <button
                type="button"
                style={{ float: 'left' }}
                className="button button-color-secondary button-shrink-limited"
                onClick={async () => {
                  setShowAlert(null);
                }}>Cancel</button>
              <button
                type="button"
                style={{ float: 'right' }}
                className="button button-color-primary button-shrink-limited"
                onClick={async () => {
                  await api.integrations.saveIntegratedResource(productId, modelNew);
                  const loadedResources = await api.integrations.getIntegratedResources(productId);
                  setResources(loadedResources);
                  setShowAlert(null);
                }}>Save</button>
              <br />
              <br />
            </form>
          </React.Fragment> : ''
      }
      {
        showAlert == 'edit' ?
          <React.Fragment>
            <form>
              <label for="ExternalIdInput">ExternalId</label>
              <input id="ExternalIdInput" name="ExternalIdInput"
                value={modelEdit.externalId}
                onChange={({ target }) => { setModelEdit({ ...modelEdit, externalId: target.value }) }} />
              <br />
              <label for="MatchExpression">Match Expression</label>
              <input id="MatchExpression" name="MatchExpression" value={modelEdit.match}
                onChange={({ target }) => { setModelEdit({ ...modelEdit, match: target.value }) }} />
              <br />
              <label for="ResourceGroupId">ResourceGroupId</label>
              <input id="ResourceGroupId" name="ResourceGroupId" value={modelEdit.resourceGroupId}
                onChange={({ target }) => { setModelEdit({ ...modelEdit, resourceGroupId: target.value }) }} />
              <br />
              <button
                type="button"
                style={{ float: 'left' }}
                className="button button-color-secondary button-shrink-limited"
                onClick={async () => {
                  setShowAlert(null);
                }}>Cancel</button>
              <button
                type="button"
                style={{ float: 'right' }}
                className="button button-color-primary button-shrink-limited"
                onClick={async () => {
                  await api.integrations.saveIntegratedResource(productId, modelEdit);
                  const loadedResources = await api.integrations.getIntegratedResources(productId);
                  setResources(loadedResources);
                  setShowAlert(null);
                }}>Save</button>
              <br />
              <br />
            </form>
          </React.Fragment> : ''
      }
      <table className='data-lists component-data-table cell-content-align-top data-table-no-results'>
        <tr style={{ backgroundColor: '#5e5e5e', color: '#f1f1f3' }}>
          <td>External Id</td>
          <td>Match</td>
          <td>Product Override</td>
          <td>Resource Name</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        {
          resources
            .map(({ externalId, match, splits, id, resourceGroupId }) => {

              return (<React.Fragment>
                {
                  splits && splits.length > 0 ?
                    splits.map(({ resources }, indexSplit) =>
                      resources.map(({ name: resourceName, product }, indexResource) =>
                      (
                        <tr>
                          {
                            indexSplit !== 0 || indexResource !== 0 ?
                              <React.Fragment>
                                <td></td>
                                <td></td>
                              </React.Fragment> :
                              <React.Fragment>
                                <td>{externalId}</td>
                                <td>{match}</td>
                              </React.Fragment>
                          }
                          {
                            <React.Fragment>
                              <td>{product}</td>
                              <td>{resourceName}</td>
                            </React.Fragment>
                          }
                          <td></td>
                          {
                            indexSplit !== 0 || indexResource !== 0 ?
                              <React.Fragment>
                                <td></td>
                                <td></td>
                              </React.Fragment> :
                              <React.Fragment>
                                <td onClick={() => {
                                  setShowAlert('edit');
                                  setModelEdit({
                                    id: id,
                                    externalId: externalId,
                                    match: match,
                                    resourceGroupId: resourceGroupId,
                                    splitted: true
                                  });
                                }}>Edit</td>
                                <td onClick={async () => {
                                  if (!confirmRemoval(externalId || match, resourceGroupId)) return;
                                  await api.integrations.removeIntegratedResource(id);
                                  const loadedResources = await api.integrations.getIntegratedResources(productId);
                                  setResources(loadedResources);
                                  setShowAlert(null);
                                }}>Remove</td>
                                <td>
                                  <Link to={`/ResourceGroup/${resourceGroupId}`}>Edit RG</Link>
                                </td>
                              </React.Fragment>
                          }
                        </tr>
                      )
                      )
                    ) :
                    <tr>
                      <td>{externalId}</td>
                      <td>{match}</td>
                      <td>none</td>
                      <td>none</td>
                      <td></td>
                      <td onClick={() => {
                        setShowAlert('edit');
                        setModelEdit({
                          id: id,
                          externalId: externalId,
                          match: match,
                          name: '',
                          productId: ''
                        });
                      }}>Edit</td>
                      <td onClick={async () => {
                        if (!confirmRemoval(externalId || match, resourceGroupId)) return;
                        await api.integrations.removeIntegratedResource(id);
                        const loadedResources = await api.integrations.getIntegratedResources(productId);
                        setResources(loadedResources);
                        setShowAlert(null);
                      }}>Remove</td>
                      <td></td>
                    </tr>
                }
              </React.Fragment>);
            })
        }
      </table>
    </React.Fragment>);
});

export const mappedGroupHeaders = [
  { value: 'BookCourt', label: 'Book Court' },
  { value: 'ParticipateActivity', label: 'Participate Activity' },
  { value: 'DropInGolf', label: 'Drop In Golf' },
  { value: 'BookHall', label: 'Book Hall' },
  { value: 'SeasonalCourt', label: 'Seasonal Court' }
];

export const validateForm = (propsToValidate) => {

  const emptyFields = [];
  let response = {
    success: false,
    type: 'error',
    message: ''
  };

  if (propsToValidate.Name.trim() == '') {
    emptyFields.push('Name');
  }
  if (propsToValidate.Provider == null) {
    emptyFields.push('Provider');
  }
  if (propsToValidate.Facility == null) {
    emptyFields.push('Facility');
  }
  if (propsToValidate.Summary.trim() == '') {
    emptyFields.push('Summary');
  }
  if (propsToValidate.Slug.trim() == '') {
    emptyFields.push('Slug');
  }
  if (propsToValidate.Photos.SquareUrl == '' || !propsToValidate.Photos.SquareUrl) {
    emptyFields.push('Square Url');
  }
  if (propsToValidate.Photos.ListUrl == '' || !propsToValidate.Photos.ListUrl) {
    emptyFields.push('List Url');
  }
  if (propsToValidate.Photos.HugeUrl == '' || !propsToValidate.Photos.HugeUrl) {
    emptyFields.push('Huge Url');
  }
  if (propsToValidate.PicturePreview == '' || !propsToValidate.PicturePreview) {
    emptyFields.push('List Picture Preview');
  }
  if (propsToValidate.Price.Amount == '' || !propsToValidate.Price.Amount) {
    emptyFields.push('Price Amount');
  }
  if (propsToValidate.SignUpDeadLine == '' || !propsToValidate.SignUpDeadLine) {
    emptyFields.push('Sign Up Dead Line');
  }
  if (propsToValidate.SignUpCancellationDeadline == '' || !propsToValidate.SignUpCancellationDeadline) {
    emptyFields.push('Sign Up Cancellation Deadline');
  }
  if (propsToValidate.Price.Level == '' || !propsToValidate.Price.Level) {
    emptyFields.push('Price Level');
  }

  if (emptyFields.length == 1) {
    response.message = `Unable to save. The ${emptyFields} field is mandatory.`
  } else if (emptyFields.length > 1) {
    response.message = `Unable to save. ${emptyFields.join(', ')} are mandatory.`
  } else {
    response.success = true;
    response.type = 'success';
  }

  return response;
}

const BookingInternal = ({
  api,
  match: {
    params: { bookingId }
  },
  categories,
  currencies,
  history
}) => {

  const [subsection, setSubsection] = useState('main');
  const [integratedResourcesView, setIntegratedResourcesView] = useState('new');
  const [hasIntegration, setHasIntegration] = useState(false);
  const [bookingLoaded, setBookingLoaded] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingContent, doEdit] = useState(null);
  const [editedNotification, setNotification] = useState(null);
  const [subTypeMapped, setSubTypeMapped] = useState(null);
  const [asNew, setAsNew] = useState(false);
  const [listPreview, setListPreview] = useState(null);
  const [picturePreviewAsBase64, setPicturePreviewAsBase64] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [aspectRatio, setAspectRatio] = useState(null);
  const [pictureLink, setPictureLink] = useState(null);
  const [format, setFormat] = useState('image/png');
  const [size, setSize] = useState(null);
  const [squarePreview, setSquarePreview] = useState(null);
  const [hugePreview, setHugePreview] = useState(null);
  const [systemType, setSystemType] = useState(null);
  const [blooLocations, setBlooLocations] = useState(null);

  const formLabelStyle = {
    display: "table-cell",
    width: "30%",
    whiteSpace: "nowrap",
    fontWeight: "bold",
    verticalAlign: "top",
  };

  const formSpanStyle = {
    display: "table-cell",
  };
  const rowStyle = {
    display: "table",
    width: "100%",
    margin: "auto auto 0px",
    position: "relative"
  };

  const inputStyle = { marginLeft: '0%' }

  const containerStyle = {
    width: '100%',
    margin: 'auto',
    backgroundColor: 'white',
    border: "1px solid #e5e5e5",
    padding: "1.2rem"
  };

  const textAreaStyle = {
    width: '100%'
  };

  const squaredSize = {
    width: 80,
    height: 80
  }
  const bannerSize = {
    width: 240,
    height: 144
  }
  const hugeSize = {
    width: 1015,
    height: 425
  }

  useEffect(() => {
    async function loadFromApi() {
      await loadData(bookingId);
    }

    if (!bookingLoaded) {
      loadFromApi();
    }
  }, [bookingLoaded]);
  const loadData = async (productId) => {
    const integration = await api.integrations.getIntegrationByProductId(productId);
    if (integration != null && integration.SystemType != 'Undefined') {
      setHasIntegration(true);
    }
    setSystemType(integration != null ? integration.SystemType : null);

    const subTypesResponse = await api.products.getSubTypes();
    setSubTypeMapped(subTypesResponse.map((x) => ({ value: x.id, label: x.name })));

    const product = await api.products.getBooking(bookingId);
    setBookingLoaded(product);

    setPicturePreviewAsBase64(product.PicturePreview);
    setListPreview(product.Photos.ListPreviewUrl);
    setSquarePreview(product.Photos.SquarePreviewUrl);
    setHugePreview(product.Photos.HugePreviewUrl);

    return product;
  };

  const handleImageChange = (e, ratio, path) => {
    if (e.target.files && e.target.files.length > 0) {
      let pictureSize;
      switch (path) {
        case 'squared':
          pictureSize = squaredSize;
          break;
        case 'list':
          pictureSize = bannerSize;
          break;
        case 'huge':
          pictureSize = hugeSize;
          break;
      }

      const file = e.target.files[0];
      const fileFormat = file.type;
      const postfix = `-${path}`;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setFormat(fileFormat);
        setImageSrc(reader.result);
        setAspectRatio(ratio);
        setPictureLink(postfix);
        setSize(pictureSize);
      };
    }
  };

  const handleImageCropped = async (croppedImage, postfix) => {
    const response = await api.products.saveImage(croppedImage, postfix, format);

    if (!response.success) {
      setNotification(new Message('error', response.message));
    } else {
      setNotification(new Message('success', 'Image saved successfully.'));
      let propertyName;

      if (response.data.includes('squared')) {
        propertyName = 'SquareUrl';
      }else if (response.data.includes('list')) {
        propertyName = 'ListUrl';
      }else if (response.data.includes('huge')) {
        propertyName = 'HugeUrl';
      }

      doEdit(
        {
          ...editingContent,
          Photos: {
            ...editingContent.Photos,
            [propertyName]: response.data
          }
        })
    }

    setImageSrc(null);
    setAspectRatio(null);
    setPictureLink(null);
    setFormat('image/png');
    setSize(null);
  };

  const onImageCancel = () => {
    setImageSrc(null);
    setAspectRatio(null);
    setPictureLink(null);
    setFormat('image/png');
    setSize(null);
  };

  const editProduct = async (event, receivedProps) => {
    receivedProps = {
      ...receivedProps,
      Photos: {
        ...receivedProps.Photos,
        BannerUrl: receivedProps.Photos.BannerUrl || '1ee9d569-4a6d-4e2e-b325-300b946f9923-list',
        SquarePreviewUrl: squarePreview,
        HugePreviewUrl: hugePreview,
        ListPreviewUrl: listPreview
      },
      PicturePreview: picturePreviewAsBase64
    };
      
    const validationResponse = validateForm(receivedProps);

    if (validationResponse.success == false) {
      event.preventDefault();
      setNotification(new Message(validationResponse.type, validationResponse.message));
      return;
    }

    try {
      const bookingId = await api.products.editBookingData(receivedProps, asNew);

      setIsEditMode(false);
      doEdit(null);
      if (asNew) {
        history.push(`/product/details/${bookingId}`);
        setNotification(new Message('success', `Booking created successfully.`));
      } else {
        loadData(bookingId);
        setNotification(new Message('success', `Booking updated successfully.`));
      }

    } catch (error) {
      setNotification(new Message('error', `Unable to update the booking. ${error}`));
    }
  }


  const invokeCleanActivitiesForProduct = async (productId) => {

    const r = window.confirm('Are you sure you want to clean activities?');

    if (r === true) {
      try {
        const { buriedActivities, cleanedActivities } = await api.activities.cleanActivitiesForProduct(productId);
        setNotification(new Message('success', `Buried ${buriedActivities}, cleaned ${cleanedActivities} activities`));
      }
      catch (e) {
        setNotification(new Message('error', 'Unable to get data'));
      }
    }
  }

  const invokeCleanActivitiesForIntegration = async (productId) => {

    const r = window.confirm('Are you sure you want to clean activities?');

    if (r === true) {
      try {
        const {
          buriedActivities,
          buriedExternalActivities,
          cleanedActivities,
          cleanedExternalActivities
        } = await api.activities.cleanActivitiesForIntegration(productId);
        setNotification(new Message('success', `Buried ${buriedActivities}, cleaned ${cleanedActivities} activities. Buried ${buriedExternalActivities}, cleaned ${cleanedExternalActivities} external activities. `));
      }
      catch (e) {
        setNotification(new Message('error', 'Unable to get data'));
      }
    }
  }

  const lookupFacility = (value) => {
    const result = api.facilities.lookupByNameOrId(value);
    return result;
  }

  const lookupProvider = (value) => {
    const result = api.providers.lookupByNameOrId(value);
    return result;
  }

  const filterProductFeature = (type) => {
    const filteredProductFeature = Object.entries(type)
      .filter(([key, value]) => value === true)
      .map(([key]) => key);

    return filteredProductFeature.join(', ');
  }

  const mappedProdutFeatureByType = (featuresByType) => {
    const courtOptions = Object.keys(featuresByType).map(feature => ({
      label: feature,
      value: featuresByType[feature],
    }));

    return courtOptions;
  }

  const mappedAmenities = (amenities) => {
    const courtOptions = Object.keys(amenities).map(x => ({
      label: x,
      value: x,
      isSelected: amenities[x]
    }));

    return courtOptions;
  }

  const handleSchemeChange = (selectedScheme) => {
    doEdit((prevContent) => ({
      ...prevContent,
      SchemeName: selectedScheme,
    }));
  };

  const handleListPreviewPicture = async (picture, postfix) => {
    const preview = await api.products.generatePreview(picture);
    setPicturePreviewAsBase64(preview);
    const response = await api.products.saveImage(preview, postfix, format);
    if (!response.success) {
      setNotification(new Message('error', response.message));
      setListPreview('');
    } else {
      setListPreview(response.data);
    }
  }

  const handleSquarePreviewPicture = async (picture, postfix) => {
      const preview = await api.products.generatePreview(picture);
      const response = await api.products.saveImage(preview, postfix, format);
      if (!response.success) {
        setNotification(new Message('error', response.message));
        setSquarePreview('');
      } else {
        
        setSquarePreview(response.data);
    }
  }

  const handleHugePreviewPicture = async (picture, postfix) => {
    const preview = await api.products.generatePreview(picture);
    const response = await api.products.saveImage(preview, postfix, format);
    if (!response.success) {
      setNotification(new Message('error', response.message));
      setHugePreview('');
    } else {
      setHugePreview(response.data);
    }
  }

  const handleProductFeatureSetting = (groupName, selectedType) => {

    let selectedTypeAsArray;
    if (Array.isArray(selectedType)) {
      selectedTypeAsArray = selectedType;
    } else if (typeof selectedType === 'object') {
      selectedTypeAsArray = [selectedType]
    }

    let formattedGroup = editingContent.ProductFeature[groupName];
    Object.keys(formattedGroup).forEach(x => formattedGroup[x] = false);
    if (selectedType != null && selectedTypeAsArray.length > 1) {
      for (const element of selectedTypeAsArray) {
        formattedGroup[element.label] = true;
      }
    } else if (selectedType != null && selectedTypeAsArray.length == 1) {
      formattedGroup[selectedTypeAsArray[0].label] = true;
    }

    doEdit({
      ...editingContent,
      ProductFeature: {
        ...editingContent.ProductFeature,
        [groupName]: formattedGroup,
      },
    });
  }
  const mappedCurrencies = currencies.map(({ Name }) => ({ value: Name, label: Name }));
  const mappedCategories = categories.map(({ Name: categoryName }) => {
    const attached = categoryName.replace(/\s+/g, '');
    return { value: attached, label: attached };
  });

  return (
    <React.Fragment>
      <Notification newMessage={editedNotification} />
      <div className='content-with-right-pane-delimiter'>
        <PageTop
          documentTitle={`booking edit page`}
          documentDescription={`booking edit page`}
        />

        <h2 className='main-page-header main-page-header-with-subheader'>
          Booking
        </h2>
        <h5 className='main-page-subheader'>{bookingLoaded ? bookingLoaded.Name : '...'}</h5>
        <br />

        {
          subsection === 'main' && bookingLoaded && !imageSrc
            ?
            (
              <div className='inner'>
                {isEditMode ? (
                  <>
                    <div style={containerStyle}>
                      <div style={rowStyle}>
                        <label for="name" style={formLabelStyle}>{"Name*"}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="name" id="name"

                            placeholder='Name'
                            value={editingContent.Name}
                            onChange={({ target }) => doEdit({ ...editingContent, Name: console.log(target.value) || target.value })} />
                        </span>
                      </div>
                      <hr />
                      <hr />
                      <div style={rowStyle}>
                        <label for="provider" style={formLabelStyle}>
                          {'Provider*'}
                        </label>
                        <span style={formSpanStyle}>
                          <AsyncSelect
                            className="react-select-filters-section"
                            classNamePrefix="react-select-filters-section-prefix"
                            defaultOptions
                            value={editingContent.Provider}
                            cacheOptions
                            onChange={(selection) =>
                              doEdit({
                                ...editingContent,
                                Provider: console.log(selection) || selection,
                              })
                            }
                            loadOptions={async (inputValue) => lookupProvider(inputValue)}
                          ></AsyncSelect>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="facility" style={formLabelStyle}>
                          {'Facility*'}
                        </label>
                        <span style={formSpanStyle}>
                          <AsyncSelect
                            className="react-select-filters-section"
                            classNamePrefix="react-select-filters-section-prefix"
                            defaultOptions
                            value={editingContent.Facility}
                            cacheOptions
                            onChange={(selection) =>
                              doEdit({
                                ...editingContent,
                                Facility: console.log(selection) || selection,
                              })
                            }
                            loadOptions={async (inputValue) => lookupFacility(inputValue)}
                          ></AsyncSelect>
                        </span>
                      </div>
                      {/* <hr />
                      <div style={rowStyle}>
                        <label for="group" style={formLabelStyle}>Group</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="group" id="group"
                            placeholder='Group'
                            value={editingContent.Group}
                            onChange={({ target }) => doEdit({ ...editingContent, Group: console.log(target.value) || target.value })} />
                        </span>
                      </div> */}
                      <hr />
                      <div style={rowStyle}>
                        <label for="group-header" style={formLabelStyle}>
                          Group Header
                        </label>
                        <span style={formSpanStyle}>
                          <ReactSelect
                            className="react-select-filters-section"
                            classNamePrefix="react-select-filters-section-prefix"
                            value={mappedGroupHeaders.filter(
                              (x) => x.value == editingContent.GroupHeader
                            )}
                            onChange={(selection) => {
                              console.log(selection);
                              doEdit({
                                ...editingContent,
                                GroupHeader: selection.value
                              });
                            }}
                            options={mappedGroupHeaders}
                          ></ReactSelect>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="summary" style={formLabelStyle}>Summary</label>
                        <span style={formSpanStyle} >
                          <textarea style={textAreaStyle} rows={2} name="summary" id="summary"
                            placeholder='Summary'
                            value={editingContent.Summary}
                            onChange={({ target }) => doEdit({ ...editingContent, Summary: console.log(target.value) || target.value })}
                          >
                          </textarea>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="description" style={formLabelStyle}>Description</label>
                        <span style={formSpanStyle} >
                          <RichTextEditor
                            value={editingContent.Description}
                            onChange={(content) => doEdit({ ...editingContent, Description: content })}
                            placeholder='Description'
                          />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="purchaseText" style={formLabelStyle}>Purchase Text</label>
                        <span style={formSpanStyle} >
                          <RichTextEditor
                            value={editingContent.PurchaseText}
                            onChange={(content) => doEdit({ ...editingContent, PurchaseText: content })}
                            placeholder='Purchase Text'
                          />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="category" style={formLabelStyle}>
                          Category
                        </label>
                        <span style={formSpanStyle}>
                          <ReactSelect
                            className="react-select-filters-section"
                            classNamePrefix="react-select-filters-section-prefix"
                            value={mappedCategories.filter(
                              (x) =>
                                x.value.toLowerCase() ===
                                (editingContent.Category || "").replace(/\s+/g, "").toLowerCase()
                            )}
                            onChange={(selection) => {
                              doEdit({
                                ...editingContent,
                                Category: console.log(selection) || (selection ? selection.value : "None"),
                              });
                            }}
                            options={mappedCategories}
                          ></ReactSelect>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="subtype" style={formLabelStyle}>
                          SubType
                        </label>
                        <span style={formSpanStyle}>
                          <ReactSelect
                            isClearable={true}
                            className="react-select-filters-section"
                            classNamePrefix="react-select-filters-section-prefix"
                            value={editingContent.SubType && subTypeMapped.filter(
                              (x) => x.value == editingContent.SubType.Id
                            )}
                            onChange={(selection) => {
                              console.log(selection);
                              doEdit({
                                ...editingContent,
                                SubType:
                                {
                                  ...editingContent.Subtype,
                                  Id: selection ? selection.value : undefined
                                }
                              });
                            }}
                            options={subTypeMapped}
                          ></ReactSelect>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="subtype" style={formLabelStyle}>
                          Scheme
                        </label>
                        <span style={formSpanStyle}>
                          <SchemeSelectorHook
                            category={editingContent.Category}
                            content={editingContent}
                            onSchemeChange={handleSchemeChange}
                          />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="is-visible" style={formLabelStyle}>
                          Is Visible
                        </label>
                        <span style={formSpanStyle}>
                          <input
                            type="checkbox"
                            checked={editingContent.IsVisible}
                            onChange={(e) => {
                              console.log(e.target)
                              doEdit({ ...editingContent, IsVisible: e.target.checked });
                            }}
                          />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="is-exclusive" style={formLabelStyle}>
                          Is Exclusive
                        </label>
                        <span style={formSpanStyle}>
                          <input
                            type="checkbox"
                            checked={editingContent.IsExclusive}
                            onChange={(e) => {
                              doEdit({ ...editingContent, IsExclusive: e.target.checked });
                            }}
                          />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="is-class-activity" style={formLabelStyle}>
                          Is Class Activity
                        </label>
                        <span style={formSpanStyle}>
                          <input
                            type="checkbox"
                            checked={editingContent.IsClassActivity}
                            onChange={(e) => {
                              doEdit({ ...editingContent, IsClassActivity: e.target.checked });
                            }}
                          />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="is-bundle-enabled" style={formLabelStyle}>
                          Is Bundle Enabled
                        </label>
                        <span style={formSpanStyle}>
                          <input
                            type="checkbox"
                            checked={editingContent.IsBundleEnabled}
                            onChange={(e) => {
                              doEdit({ ...editingContent, IsBundleEnabled: e.target.checked });
                            }}
                          />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="external-link" style={formLabelStyle}>External Link</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="external-link" id="external-link"
                            placeholder='External Link'
                            value={editingContent.ExternalLink}
                            onChange={({ target }) => {
                              doEdit({ ...editingContent, ExternalLink: target.value })
                            }} />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="terms-of-service-link" style={formLabelStyle}>Terms Of Service Link </label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="terms-of-service-link" id="terms-of-service-link"
                            placeholder='Terms Of Service Link'
                            value={editingContent.TermsOfServiceLink}
                            onChange={({ target }) => doEdit({ ...editingContent, TermsOfServiceLink: console.log(target.value) || target.value })} />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="condition-text" style={formLabelStyle}>Condition Text</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="condition-text" id="condition-text"
                            placeholder='Condition Text'
                            value={editingContent.ConditionText}
                            onChange={({ target }) => doEdit({ ...editingContent, ConditionText: console.log(target.value) || target.value })} />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="sorting-preference" style={formLabelStyle}>Sorting Preference</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="sorting-preference" id="sorting-preference"
                            placeholder='Sorting Preference'
                            value={editingContent.SortingPreference}
                            onChange={({ target }) => {
                              console.log(target.value);
                              doEdit({ ...editingContent, SortingPreference: target.value.trim() })
                            }} />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="slug" style={formLabelStyle}>Slug</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="slug" id="slug"
                            placeholder='Slug'
                            value={editingContent.Slug}
                            onChange={({ target }) => doEdit({ ...editingContent, Slug: console.log(target.value) || target.value })} />
                        </span>
                      </div>
                    </div>
                    <br />
                    <h4 className='main-page-subheader'>Pictures</h4>
                    <br />
                    <div style={containerStyle}>
                      <div style={rowStyle}>
                        <label for="square-url" style={formLabelStyle}>{'Square Url*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="square-url" id="square-url"
                            placeholder='Square Url'
                            value={editingContent.Photos.SquareUrl}
                            onChange={({ target }) => {
                              doEdit(
                                {
                                  ...editingContent,
                                  Photos: {
                                    ...editingContent.Photos,
                                    SquareUrl: console.log(target.value) || target.value
                                  }
                                })
                            }}
                          />
                        </span>
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label for="logo" style={formLabelStyle}></label>
                        <span style={formSpanStyle} >
                          <Image link={editingContent.Photos.SquareUrl} />
                        </span>
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label style={formLabelStyle} htmlFor="fileSquareInput">Load a picture:</label>
                        <input style={inputStyle} type="file" id="fileSquareInput" accept="image/*" onChange={(e) => handleImageChange(e, 1, 'squared')} />
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label style={formLabelStyle} htmlFor="squaredPreviewButton"></label>
                        {editingContent.Photos.SquareUrl && editingContent.Photos.SquareUrl.trim() != '' ?
                          <button onClick={() => handleSquarePreviewPicture(editingContent.Photos.SquareUrl, '-squared-preview')}>Generate Preview</button> :
                          <button disabled>Generate Preview</button>
                        }
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="square-preview" style={formLabelStyle}>{'Square Preview'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} disabled name="square-preview" id="square-preview"
                            placeholder='Square Preview'
                            value={squarePreview}
                            />
                        </span>
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label for="logo" style={formLabelStyle}></label>
                        <span style={formSpanStyle} >
                          <Image link={squarePreview} />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="list-url" style={formLabelStyle}>{'List Url*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="list-url" id="list-url"
                            placeholder='List Url'
                            value={editingContent.Photos.ListUrl}
                            onChange={({ target }) => {
                              console.log(target.value);
                              doEdit(
                                {
                                  ...editingContent,
                                  Photos: {
                                    ...editingContent.Photos,
                                    ListUrl: target.value
                                  }
                                })
                            }}
                             />
                        </span>
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label for="logo" style={formLabelStyle}></label>
                        <span style={formSpanStyle} >
                          <Image link={editingContent.Photos.ListUrl} />
                        </span>
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label style={formLabelStyle} htmlFor="fileListInput">Load a picture:</label>
                        <input style={inputStyle} type="file" id="fileListInput" accept="image/*" onChange={(e) => handleImageChange(e, (240 / 144), 'list')} />
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label style={formLabelStyle} htmlFor="listPreviewButton"></label>
                        {editingContent.Photos.ListUrl && editingContent.Photos.ListUrl.trim() != '' ?
                          <button onClick={() => handleListPreviewPicture(editingContent.Photos.ListUrl, '-list-preview')}>Generate Preview</button> :
                          <button disabled>Generate Preview</button>
                        }
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="picture-preview" style={formLabelStyle}>{'List Preview'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} disabled name="picture-preview" id="picture-preview"
                            placeholder='List Preview'
                            value={listPreview}
                            />
                        </span>
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label for="logo" style={formLabelStyle}></label>
                        <span style={formSpanStyle} >
                          <Image link={listPreview} />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="huge-url" style={formLabelStyle}>{'Huge Url*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="huge-url" id="huge-url"
                            placeholder='Huge Url'
                            value={editingContent.Photos.HugeUrl}
                            onChange={({ target }) => doEdit(
                              {
                                ...editingContent,
                                Photos: {
                                  ...editingContent.Photos,
                                  HugeUrl: console.log(target.value) || target.value
                                }
                              })} />
                        </span>
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label for="logo" style={formLabelStyle}></label>
                        <span style={formSpanStyle} >
                          <Image link={editingContent.Photos.HugeUrl} />
                        </span>
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label style={formLabelStyle} htmlFor="fileHugeInput">Load a picture:</label>
                        <input style={inputStyle} type="file" id="fileHugeInput" accept="image/*" onChange={(e) => handleImageChange(e, (1015 / 425), 'huge')} />
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label style={formLabelStyle} htmlFor="hugePreviewButton"></label>
                        {editingContent.Photos.HugeUrl && editingContent.Photos.HugeUrl.trim() != '' ?
                          <button onClick={() => handleHugePreviewPicture(editingContent.Photos.HugeUrl, '-huge-preview')}>Generate Preview</button> :
                          <button disabled>Generate Preview</button>
                        }
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="huge-preview" style={formLabelStyle}>{'Huge Preview'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} disabled name="huge-preview" id="huge-preview"
                            placeholder='Huge Preview'
                            value={hugePreview}
                          />
                        </span>
                      </div>
                      <br />
                      <div style={rowStyle}>
                        <label for="logo" style={formLabelStyle}></label>
                        <span style={formSpanStyle} >
                          <Image link={hugePreview} />
                        </span>
                      </div>
                    </div>
                    <br />
                    <h4 className='main-page-subheader'>Price</h4>
                    <br />
                    <div style={containerStyle}>
                      <div style={rowStyle}>
                        <label for="amount" style={formLabelStyle}>{"Amount*"}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="amount" id="amount"
                            placeholder='Amount'
                            value={editingContent.Price.Amount}
                            onChange={({ target }) => doEdit(
                              {
                                ...editingContent, Price: {
                                  ...editingContent.Price,
                                  Amount: console.log(target.value) || target.value
                                }
                              })} />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="currency-iso-code" style={formLabelStyle}>
                          {'Currency Iso Code*'}
                        </label>
                        <span style={formSpanStyle}>
                          <ReactSelect
                            className="react-select-filters-section"
                            classNamePrefix="react-select-filters-section-prefix"
                            value={mappedCurrencies.filter(
                              (x) => x.label == editingContent.Price.CurrencyIsoCode
                            )}
                            onChange={(selection) => {
                              console.log(selection.value);
                              doEdit({
                                ...editingContent,
                                Price: {
                                  ...editingContent.Price,
                                  CurrencyIsoCode: selection ? selection.value : "None"
                                },
                              });
                            }}
                            options={mappedCurrencies}
                          ></ReactSelect>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="tax-index" style={formLabelStyle}>Tax Index</label>
                        <span style={{ ...formSpanStyle, width: '85%' }} >
                          <input style={inputStyle} name="tax-index" id="tax-index"

                            placeholder='Tax Index'
                            value={editingContent.Price.TaxIndex.AsDecimal}
                            onChange={({ target }) => {
                              console.log(target)
                              doEdit(
                                {
                                  ...editingContent, Price: {
                                    ...editingContent.Price, TaxIndex: {
                                      ...editingContent.Price.TaxIndex,
                                      AsDecimal: target.value || ''
                                    }
                                  }
                                })
                            }} />
                        </span>{' %'}
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="tax-amount" style={formLabelStyle}>Tax Amount</label>
                        <span style={formSpanStyle} >
                          <DisplayCurrencyAmount amount={editingContent.Price.TaxAmount} currency={editingContent.Price.CurrencyIsoCode} />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="fee" style={formLabelStyle}>Service Fee Amount</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle} name="fee" id="fee"
                            placeholder='Service Fee Amount'
                            value={editingContent.Price.ServiceFeeAmount}
                            onChange={({ target }) => {
                              console.log(target.value)
                              doEdit(
                              {
                                ...editingContent, Price: {
                                  ...editingContent.Price, ServiceFeeAmount: target.value && target.value.trim() 
                                }
                              })}} />
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="price-level" style={formLabelStyle}>
                          {'Price Level'}
                        </label>
                        <span style={formSpanStyle}>
                          <ReactSelect
                            className="react-select-filters-section"
                            classNamePrefix="react-select-filters-section-prefix"
                            value={mappedPriceLevels.filter(
                              (x) => x.label == editingContent.Price.Level
                            )}
                            onChange={(selection) => {
                              console.log(selection);
                              doEdit({
                                ...editingContent,
                                Price: {
                                  ...editingContent.Price,
                                  Level: selection.value
                                },
                              });
                            }}
                            options={mappedPriceLevels}
                          ></ReactSelect>
                        </span>
                      </div>
                    </div>
                    <br />
                    {bookingLoaded.Type !== 'Booking' ? '' : <React.Fragment>
                    <h4 className='main-page-subheader'>Booking</h4>
                    <br />
                    <div style={containerStyle}>
                      <div style={rowStyle}>
                        <label for="signup-deadline" style={{ ...formLabelStyle, width: '40%' }}>{'Signup Deadline*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.SignUpDeadLine}
                            placeholder="Signup Deadline"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, SignUpDeadLine: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="signup-cancellation-deadline" style={{ ...formLabelStyle, width: '40%' }}>{'Signup Cancellation Deadline*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.SignUpCancellationDeadline}
                            placeholder="Signup Cancellation Deadline"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, SignUpCancellationDeadline: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="bundle-deadline" style={{ ...formLabelStyle, width: '40%' }}>{'Bundle Deadline'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.BundleDeadline || ''}
                            placeholder="Bundle Deadline (empty = cancellation deadline + 4h)"
                            onChange={(e) => {
                              doEdit({ ...editingContent, BundleDeadline: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="max-sign-up-in-advance-in-days" style={{ ...formLabelStyle, width: '40%' }}>Max Sign Up In Advance In Days</label>
                        <span style={{ formSpanStyle }} >
                          <input style={inputStyle}
                            value={editingContent.MaxSignUpInAdvanceInDays}
                            placeholder="Max Sign Up In Advance In Days"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, MaxSignUpInAdvanceInDays: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                    </div>
                    <br />
                    </React.Fragment>}
                    {bookingLoaded.Type !== 'Membership' ? '' : <React.Fragment>
                    <h4 className='main-page-subheader'>Membership</h4>
                    <div style={containerStyle}>
                      <div style={rowStyle}>
                        <label for="DefaultPriceCoverage" style={{ ...formLabelStyle, width: '40%' }}>{'DefaultPriceCoverage*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.DefaultPriceCoverage}
                            placeholder="DefaultPriceCoverage"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, DefaultPriceCoverage: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="MaxDiscountedAmount" style={{ ...formLabelStyle, width: '40%' }}>{'MaxDiscountedAmount*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.MaxDiscountedAmount}
                            placeholder="MaxDiscountedAmount"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, MaxDiscountedAmount: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="CategoriesIncluded" style={{ ...formLabelStyle, width: '40%' }}>{'CategoriesIncluded*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.CategoriesIncluded}
                            placeholder="CategoriesIncluded"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, CategoriesIncluded: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="MaxPurchasesIncluded" style={{ ...formLabelStyle, width: '40%' }}>{'MaxPurchasesIncluded*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.MaxPurchasesIncluded}
                            placeholder="MaxPurchasesIncluded"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, MaxPurchasesIncluded: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="IsAllProductsIncluded" style={{ ...formLabelStyle, width: '40%' }}>{'IsAllProductsIncluded*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.IsAllProductsIncluded}
                            placeholder="IsAllProductsIncluded"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, IsAllProductsIncluded: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="DefaultPriceLevelCoverage" style={{ ...formLabelStyle, width: '40%' }}>{'DefaultPriceLevelCoverage*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.DefaultPriceLevelCoverage}
                            placeholder="DefaultPriceLevelCoverage"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, DefaultPriceLevelCoverage: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="DeferredStart" style={{ ...formLabelStyle, width: '40%' }}>{'DeferredStart'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.DeferredStart}
                            placeholder="DeferredStart"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, DeferredStart: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="LogicType" style={{ ...formLabelStyle, width: '40%' }}>{'LogicType'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.LogicType}
                            placeholder="LogicType"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, LogicType: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="CoveredFacilityId" style={{ ...formLabelStyle, width: '40%' }}>{'CoveredFacilityId'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.CoveredFacilityId}
                            placeholder="CoveredFacilityId"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, CoveredFacilityId: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="TrackDiscountedAmount" style={{ ...formLabelStyle, width: '40%' }}>{'TrackDiscountedAmount'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.TrackDiscountedAmount}
                            placeholder="TrackDiscountedAmount"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, TrackDiscountedAmount: e.target.value === "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="FixedDiscount" style={{ ...formLabelStyle, width: '40%' }}>{'FixedDiscount'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.FixedDiscount}
                            placeholder="FixedDiscount"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, FixedDiscount: e.target.value === "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="OneTimeSubscription" style={{ ...formLabelStyle, width: '40%' }}>{'OneTimeSubscription'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.OneTimeSubscription}
                            placeholder="OneTimeSubscription"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, OneTimeSubscription: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <hr />
                      <div style={rowStyle}>
                        <label for="BillingLength" style={{ ...formLabelStyle, width: '40%' }}>{'BillingLength*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.BillingLenght}
                            placeholder="BillingLength"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, BillingLenght: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="BillingStartType" style={{ ...formLabelStyle, width: '40%' }}>{'BillingStartType*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.BillingStartType}
                            placeholder="BillingStartType"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, BillingStartType: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="BillingType" style={{ ...formLabelStyle, width: '40%' }}>{'BillingType*'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.BillingType}
                            placeholder="BillingType"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, BillingType: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="TerminationLenght" style={{ ...formLabelStyle, width: '40%' }}>{'TerminationLenght'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.TerminationLenght}
                            placeholder="TerminationLenght"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, TerminationLenght: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="TerminationStartType" style={{ ...formLabelStyle, width: '40%' }}>{'TerminationStartType'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.TerminationStartType}
                            placeholder="TerminationStartType"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, TerminationStartType: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="TerminationType" style={{ ...formLabelStyle, width: '40%' }}>{'TerminationType'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.TerminationType}
                            placeholder="TerminationType"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, TerminationType: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="BucketLenght" style={{ ...formLabelStyle, width: '40%' }}>{'BucketLenght'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.BucketLenght}
                            placeholder="BucketLenght"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, BucketLenght: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="BucketStartType" style={{ ...formLabelStyle, width: '40%' }}>{'BucketStartType'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.BucketStartType}
                            placeholder="BucketStartType"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, BucketStartType: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="BucketType" style={{ ...formLabelStyle, width: '40%' }}>{'BucketType'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.BucketType}
                            placeholder="BucketType"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, BucketType: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                      <hr />
                      <div style={rowStyle}>
                        <label for="RequiredDomain" style={{ ...formLabelStyle, width: '40%' }}>{'RequiredDomain'}</label>
                        <span style={formSpanStyle} >
                          <input style={inputStyle}
                            value={editingContent.RequiredDomain}
                            placeholder="RequiredDomain"
                            onChange={(e) => {
                              console.log(e.target.value);
                              doEdit({ ...editingContent, RequiredDomain: e.target.value == "" ? null : e.target.value });
                            }}
                          ></input>
                        </span>
                      </div>
                    </div>
                    </React.Fragment>}
                    {bookingLoaded.Type !== 'Booking' ? '' : <React.Fragment>
                      <br />
                      <h4 className='main-page-subheader'>Product Features</h4>
                      <br />
                      <div style={containerStyle}>
                        <div style={rowStyle}>
                          <label for="court-type" style={formLabelStyle}>
                            Court Type
                          </label>
                          <span style={formSpanStyle}>
                            <ReactSelect
                              className="react-select-filters-section"
                              classNamePrefix="react-select-filters-section-prefix"
                              isClearable={true}
                              value={mappedProdutFeatureByType(editingContent.ProductFeature.CourtType).find(
                                (x) => x.value === true)}
                              onChange={(selection) => {
                                console.log(selection);
                                handleProductFeatureSetting("CourtType", selection)
                              }}
                              options={mappedProdutFeatureByType(editingContent.ProductFeature.CourtType)}
                            ></ReactSelect>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="amenities" style={formLabelStyle}>
                            Amenities
                          </label>
                          <span style={formSpanStyle}>
                            <ReactSelect
                              isMulti
                              className="react-select-filters-section"
                              classNamePrefix="react-select-filters-section-prefix basic-multi-select"
                              defaultValue={mappedAmenities(editingContent.ProductFeature.Amenities).filter(
                                (x) => x.isSelected === true)}
                              onChange={(selection) => {
                                console.log(selection);
                                handleProductFeatureSetting("Amenities", selection)
                              }}
                              options={mappedAmenities(editingContent.ProductFeature.Amenities)}
                            ></ReactSelect>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="coverage" style={formLabelStyle}>
                            Coverage
                          </label>
                          <span style={formSpanStyle}>
                            <ReactSelect
                              className="react-select-filters-section"
                              classNamePrefix="react-select-filters-section-prefix"
                              isClearable={true}
                              value={mappedProdutFeatureByType(editingContent.ProductFeature.Coverage).find(
                                (x) => x.value === true)}
                              onChange={(selection) => {
                                console.log(selection);
                                handleProductFeatureSetting("Coverage", selection)
                              }}
                              options={mappedProdutFeatureByType(editingContent.ProductFeature.Coverage)}
                            ></ReactSelect>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="hall-type" style={formLabelStyle}>
                            Hall Type
                          </label>
                          <span style={formSpanStyle}>
                            <ReactSelect
                              className="react-select-filters-section"
                              classNamePrefix="react-select-filters-section-prefix"
                              isClearable={true}
                              value={mappedProdutFeatureByType(editingContent.ProductFeature.HallType).find(
                                (x) => x.value === true)}
                              onChange={(selection) => {
                                console.log(selection);
                                handleProductFeatureSetting("HallType", selection)
                              }}
                              options={mappedProdutFeatureByType(editingContent.ProductFeature.HallType)}
                            ></ReactSelect>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="size" style={formLabelStyle}>
                            Size
                          </label>
                          <span style={formSpanStyle}>
                            <ReactSelect
                              className="react-select-filters-section"
                              classNamePrefix="react-select-filters-section-prefix"
                              isClearable={true}
                              value={mappedProdutFeatureByType(editingContent.ProductFeature.Size).find(
                                (x) => x.value === true)}
                              onChange={(selection) => {
                                console.log(selection);
                                handleProductFeatureSetting("Size", selection)
                              }}
                              options={mappedProdutFeatureByType(editingContent.ProductFeature.Size)}
                            ></ReactSelect>
                          </span>
                        </div>
                      </div>
                    </React.Fragment>}
                    <hr />
                    <h4 className='main-page-subheader'>Save Mode</h4>
                    <br />
                    <div style={containerStyle}>
                    <div style={rowStyle}>
                      <label for="save-as-new" style={formLabelStyle}>
                        Save as new
                      </label>
                      <span
                        style={{
                          ...formSpanStyle,
                          textDecoration: 'underline',
                          cursor: 'pointer'
                        }}
                        onClick={() => setAsNew(!asNew)}
                      >
                        {asNew ? 'yes' : 'no'}
                      </span>
                    </div>
                    </div>
                    <div style={{ 'display': 'flex', 'justifyContent': 'center', 'marginTop': '2%' }}>
                      <br />
                      <br />
                      <div style={{ marginRight: '2%' }}>
                        <ButtonOBSOLETED
                          type="submit"
                          buttonContent="Save"
                          onClick={async (e) => {
                            await editProduct(e, editingContent);
                          }} />
                      </div>
                      <div>
                        <ButtonOBSOLETED
                          type="reset"
                          buttonContent="Cancel"
                          onClick={() => {
                            setIsEditMode(false);
                            setPicturePreview(bookingLoaded.PicturePreview || null)
                            setAsNew(false)
                            doEdit(null);
                          }} />
                      </div>
                    </div>
                  </>
                ) : <>
                  <div>
                    <DataDefinitionList
                      listData={{
                        Id: <DisplayGuid>{bookingLoaded.Id}</DisplayGuid>,
                        Type: <DisplayType>{bookingLoaded.Type}</DisplayType>,
                        CreatedAt: <DisplayDate>{bookingLoaded.CreatedAt}</DisplayDate>,
                        'Name*': bookingLoaded.Name,
                        'Provider*': <>{bookingLoaded.ProviderName} - <DisplayGuid short baseAnchor='/provider'>{bookingLoaded.ProviderId}</DisplayGuid></>,
                        'Facility*': <>{bookingLoaded.FacilityName} - <DisplayGuid short baseAnchor='/facility'>{bookingLoaded.FacilityId}</DisplayGuid></>,
                        //Group: '',
                        'Group Header': mappedGroupHeaders.find(x => x.value === bookingLoaded.GroupHeader).label,
                        'Summary*': bookingLoaded.Summary,
                        'Description*': <HtmlContent html={bookingLoaded.Description} />,
                        'Purchase Text': <HtmlContent html={bookingLoaded.PurchaseText} />,
                        'Category*': bookingLoaded.Category,
                        SubType: bookingLoaded.SubType ? bookingLoaded.SubType.Name : "",
                        Scheme: <>{descriptionScheme(bookingLoaded.Scheme)} </>,
                        'Is Visible': <DisplayBoolean>{bookingLoaded.IsVisible}</DisplayBoolean>,
                        'Is Exclusive': <DisplayBoolean>{bookingLoaded.IsExclusive}</DisplayBoolean>,
                        'Is Class Activity': <DisplayBoolean>{bookingLoaded.IsClassActivity}</DisplayBoolean>,
                        'Is Bundle Enabled': <DisplayBoolean>{bookingLoaded.IsBundleEnabled}</DisplayBoolean>,
                        'External Link': bookingLoaded.ExternalLink || '',
                        'Terms Of Service Link': bookingLoaded.TermsOfServiceLink || '',
                        'Condition Text': bookingLoaded.ConditionText || '',
                        'Sorting Preference': bookingLoaded.SortingPreference,
                        Slug: bookingLoaded.Slug || '',
                      }
                      }
                      classNames={['detail-page-list']}
                    />
                    <h4 className='main-page-subheader'>Pictures</h4>
                    <br />
                    {bookingLoaded && (
                      <DataDefinitionList
                        listData={{
                          'Square Url*': bookingLoaded.Photos.SquareUrl ? (
                            <>
                              <div>
                                {bookingLoaded.Photos.SquareUrl}
                              </div>
                              <div>
                                <Image link={bookingLoaded.Photos.SquareUrl} />
                              </div>
                            </>
                          ) : '',
                            'Square Preview': bookingLoaded.Photos.SquarePreviewUrl ? (
                              <>
                                <div>
                                  {bookingLoaded.Photos.SquarePreviewUrl}
                                </div>
                                <div>
                                  <Image link={bookingLoaded.Photos.SquarePreviewUrl} />
                                </div>
                              </>
                            ) : '',
                            'List Url*': bookingLoaded.Photos.ListUrl ? (
                              <>
                                <div>
                                  {bookingLoaded.Photos.ListUrl}
                                </div>
                                <div>
                                  <Image link={bookingLoaded.Photos.ListUrl} />
                                </div>
                              </>
                            ) : '',
                            'List Preview': listPreview ? (
                              <>
                                <div>
                                  {listPreview}
                                </div>
                                <div>
                                  <Image link={listPreview} />
                                </div>
                              </>
                            ) : '',
                            'List Preview (Base64)': bookingLoaded.PicturePreview ? (
                              <>
                                <textarea rows={3} disabled>
                                  {picturePreviewAsBase64}
                                </textarea>
                                <div>
                                  <Image link={picturePreviewAsBase64} />
                                </div>
                              </>
                            ) : '',
                          'Huge Url*': bookingLoaded.Photos.HugeUrl ? (
                            <>
                              <div>
                                {bookingLoaded.Photos.HugeUrl}
                              </div>
                              <div>
                                <Image link={bookingLoaded.Photos.HugeUrl} />
                              </div>
                            </>
                          ) : '',
                            'Huge Preview': bookingLoaded.Photos.HugePreviewUrl ? (
                              <>
                                <div>
                                  {bookingLoaded.Photos.HugePreviewUrl}
                                </div>
                                <div>
                                  <Image link={bookingLoaded.Photos.HugePreviewUrl}/>
                                </div>
                              </>
                            ) : ''
                        }}
                        classNames={['detail-page-list']}
                      />)}
                    <h4 className='main-page-subheader'>Price</h4>
                    <br />
                    {bookingLoaded && (
                      <DataDefinitionList
                        listData={{
                          'Amount*': <DisplayCurrencyAmount amount={bookingLoaded.Price.Amount} currency={bookingLoaded.Price.CurrencyIsoCode} />,
                          'Currency Iso Code*': bookingLoaded.Price.CurrencyIsoCode,
                          'Tax Index': <DisplayPercentage>
                            {{ AsPercentage: (bookingLoaded.Price.TaxIndex.AsDecimal * 100) }}
                          </DisplayPercentage>,
                          'Tax Amount': <DisplayCurrencyAmount amount={bookingLoaded.Price.TaxAmount} currency={bookingLoaded.Price.CurrencyIsoCode} />,
                          'Service Fee Amount': <DisplayCurrencyAmount
                            amount={bookingLoaded.Price.ServiceFeeAmount}
                            currency={bookingLoaded.Price.CurrencyIsoCode}
                          />,
                          'Price Level': bookingLoaded.Price.Level,
                        }}
                        classNames={['detail-page-list']}
                      />)}
                    
                    {bookingLoaded.Type !== 'Booking' ? '' : <React.Fragment>
                      <h4 className='main-page-subheader'>Booking</h4>
                      <br />
                      {bookingLoaded && (
                        <DataDefinitionList
                          listData={{
                            'Signup Deadline*': bookingLoaded.SignUpDeadLine,
                            'Signup Cancellation Deadline*': bookingLoaded.SignUpCancellationDeadline,
                            'Bundle Deadline': bookingLoaded.BundleDeadline || 'Cancellation deadline + 4h',
                            'Max Sign Up In Advance In Days': bookingLoaded.MaxSignUpInAdvanceInDays || '',
                          }}
                          classNames={['detail-page-list']}
                        />)}
                    </React.Fragment>}
                    {bookingLoaded.Type !== 'Membership' ? '' : <React.Fragment>
                      <h4 className='main-page-subheader'>Membership</h4>
                      <br />
                      {bookingLoaded && (
                        <DataDefinitionList
                          listData={{
                            'DefaultPriceCoverage*': bookingLoaded.DefaultPriceCoverage || '',
                            'Max Discounted Amount': bookingLoaded.MaxDiscountedAmount || '',
                            'Categories Included*': bookingLoaded.CategoriesIncluded || '',
                            'Max Purchases Included*': bookingLoaded.MaxPurchasesIncluded || '',
                            'All Products Included*': bookingLoaded.IsAllProductsIncluded || '',
                            'Default Price Level Coverage*': bookingLoaded.DefaultPriceLevelCoverage || '',
                            'Deferred Start*': bookingLoaded.DeferredStart || '',
                            'Logic Type*': bookingLoaded.LogicType || '',
                            'Covered Facility Id*': bookingLoaded.CoveredFacilityId || '',
                            'Track Discounted Amount*': bookingLoaded.TrackDiscountedAmount || '',
                            'Fixed Discount*': bookingLoaded.FixedDiscount|| '',
                            'One Time Subscription*': bookingLoaded.OneTimeSubscription || '',
                            "Billing Lenght": bookingLoaded.BillingLenght || '',
                            "Billing StartType": bookingLoaded.BillingStartType || '',
                            "Billing Type": bookingLoaded.BillingType || '',
                            "Termination Length": bookingLoaded.TerminationLenght || '',
                            "Termination StartType": bookingLoaded.TerminationStartType || '',
                            "Termination TerminationType": bookingLoaded.TerminationType || '',
                            "Bucket Length": bookingLoaded.BucketLenght || '',
                            "Bucket StartType": bookingLoaded.BucketStartType || '',
                            "Bucket TerminationType": bookingLoaded.BucketType || '',
                            'Email Domain': bookingLoaded.RequiredDomain || '',
                          }}
                          classNames={['detail-page-list']}
                        />)}
                     </React.Fragment>}
                    {bookingLoaded.Type !== 'Booking' ? '' : <React.Fragment>
                      <h4 className='main-page-subheader'>Product Features</h4>
                      <br />
                      {bookingLoaded && (
                        <DataDefinitionList
                          listData={{
                            'Court Type': <>{filterProductFeature(bookingLoaded.ProductFeature.CourtType)}</>,
                            'Amenities': <>{filterProductFeature(bookingLoaded.ProductFeature.Amenities)}</>,
                            'Coverage': <>{filterProductFeature(bookingLoaded.ProductFeature.Coverage)}</>,
                            'Hall Type': <>{filterProductFeature(bookingLoaded.ProductFeature.HallType)}</>,
                            'Size': <>{filterProductFeature(bookingLoaded.ProductFeature.Size)}</>,
                          }}
                          classNames={['detail-page-list']}
                        />)}
                    </React.Fragment>}
                    <div style={{ 'display': 'flex', 'justifyContent': 'center' }}>
                      <br />
                      <ButtonOBSOLETED
                        type="submit"
                        buttonContent="Edit"
                        onClick={() => {
                          setIsEditMode(true);
                          doEdit(
                            {
                              ...bookingLoaded,
                              // The API returns the tax index as a fraction (0.25); the form
                              // field is a percentage and is divided by 100 again on save.
                              Price: {
                                ...bookingLoaded.Price,
                                TaxIndex: {
                                  ...bookingLoaded.Price.TaxIndex,
                                  AsDecimal: Math.round((bookingLoaded.Price.TaxIndex?.AsDecimal || 0) * 10000) / 100
                                }
                              },
                              Facility: { value: bookingLoaded.FacilityId, label: bookingLoaded.FacilityName },
                              Provider: { value: bookingLoaded.ProviderId, label: bookingLoaded.ProviderName }
                            });
                        }} />
                    </div>
                  </div>
                </>}
              </div>
            )
            : imageSrc ? (
              <ImageCropper imageSrc={imageSrc} aspectRatio={aspectRatio} pictureSize={size} format={format} onCancel={onImageCancel} link={pictureLink} onImageCropped={handleImageCropped} />
            )
            : ''
        }
        {
          subsection === 'fields'
            ? (
              <div className='inner'>
                <ProductFields productId={bookingId} />
              </div>
            ) : ''
        }
        {
          subsection === 'integration'
            ? (
              <div className='inner'>
                <Integration productId={bookingId} loadData={loadData} />
              </div>
            ) : ''
        }
        {
          subsection === 'price-rules'
            ? (
              <div className=''>
                <PriceRules productId={bookingId} />
              </div>
            ) : ''
        }
        {
          subsection === 'availability-info'
            ? (
              <div className='inner'>
                <AvailabilityInfo productId={bookingId} />
              </div>
            ) : ''
        }
        {
          subsection === 'integrated-resources'
            ? (
              <div className='inner'>
                <ViewSwitch
                  value={integratedResourcesView}
                  onChange={setIntegratedResourcesView}
                  views={INTEGRATED_RESOURCES_VIEWS}
                />
                {integratedResourcesView === 'new' && (
                  <IntegratedResourcesBoard productId={bookingId} facilityId={bookingLoaded?.FacilityId} />
                )}
                {integratedResourcesView === 'classic' && <IntegratedResources productId={bookingId} />}
                {integratedResourcesView === 'layout' && <IntegratedResourcesLayout productId={bookingId} />}
              </div>
            ) : ''
        }
        {
          subsection === 'relay'
            ? (
              <div className='inner'>
                <Relay productId={bookingId} />
              </div>
            ) : ''
        }
        {
          subsection === 'schedule'
            ? (
              <div className='inner'>
                <Schedule productId={bookingId} />
              </div>
            ) : ''
        }
        {
          subsection === 'crawlFilters'
            ? (
              <div>
                <CrawlFilters productId={bookingId} />
              </div>
            ) : ''
        }
      </div>
      {
        blooLocations ? (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div style={{ background: '#fff', padding: 20, width: 'min(800px, 90vw)', maxHeight: '85vh', display: 'flex', flexDirection: 'column', borderRadius: 4 }}>
              <h4 style={{ marginTop: 0 }}>Bloo locations</h4>
              <pre style={{ flex: 1, minHeight: 0, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', margin: 0 }}>{JSON.stringify(blooLocations, null, 2)}</pre>
              <button
                type="button"
                style={{ marginTop: 16, alignSelf: 'flex-start' }}
                className="button button-color-primary button-shrink-limited"
                onClick={() => setBlooLocations(null)}
              >Close</button>
            </div>
          </div>
        ) : ''
      }
      <DetailsRightBar>
        <Divider>Links</Divider>
        {
          bookingLoaded ? <Link to={`/purchases?productId=${bookingLoaded.Id}`}>Purchases</Link> : ''
        }
        {
          bookingLoaded ? <Link to={`/crawlings?productId=${bookingLoaded.Id}`}>Crawlings</Link> : ''
        }
        {
          bookingLoaded ? <Link to={`/activities?productId=${bookingLoaded.Id}`}>Activities</Link> : ''
        }
        <Divider>Actions</Divider>
        {
          bookingLoaded ? (
            <Action action={async () => {
              await invokeCleanActivitiesForProduct(bookingLoaded.Id);
            }}
            >
              Clean Product Act.
            </Action>
          ) : ''
        }
        {
          (bookingLoaded && hasIntegration != null && hasIntegration == true) ? (
            <Action action={async () => {
              await invokeCleanActivitiesForIntegration(bookingLoaded.Id);
            }}
            >
              Clean Integration Act.
            </Action>
          ) : ''
        }
        {
          systemType === 'Bloo' ? (
            <Action action={async () => {
              try {
                const locations = await api.integrations.getBlooLocations();
                setBlooLocations(locations);
              } catch (e) {
                setBlooLocations({ error: String(e) });
              }
            }}
            >
              Bloo Locations
            </Action>
          ) : ''
        }
        <Divider>Sections</Divider>
        <Action action={() => {
          setSubsection('main');
        }}
        >
          Main
        </Action>
        <Action action={() => {
          setSubsection('fields');
        }}
        >
          Custom Fields
        </Action>
        <Action action={() => {
          setSubsection('price-rules');
        }}
        >
          Price Rules
        </Action>
        <Action action={() => {
          setSubsection('integration');
        }}
        >
          Integration
        </Action>
        {hasIntegration != null && hasIntegration == true ? (
          <Action action={() => {
            setSubsection('availability-info');
          }}
          >
            Availability Info
          </Action>
        ) : ''}

        {hasIntegration != null && hasIntegration == true ?
          (<Action action={() => {
            setSubsection('integrated-resources');
          }}
          >
            Integrated resources
          </Action>) :
          ''}

        {hasIntegration != null && hasIntegration == true ? (<Action action={() => {
          setSubsection('relay');
        }}
        >
          Email Notification
        </Action>) :
          ''}
        {hasIntegration != null && hasIntegration == true ?
          (<Action action={() => {
            setSubsection('schedule');
          }}
          >
            Schedule
          </Action>) :
          ''}

        {hasIntegration != null && hasIntegration == true ?
          (<Action action={() => {
            setSubsection('crawlFilters');
          }}
          >
            Crawl Filters
          </Action>) :
          ''}

      </DetailsRightBar>
    </React.Fragment>
  );
}

const BookingDetails = withRouter(withApi(
  connect(({ user, categories, currencies }) =>
    ({ isLoggedIn: !!user, categories, currencies }), {})(BookingInternal)
));

BookingDetails.requiresLogin = true;
BookingDetails.propTypes = { isLoggedIn: PropTypes.bool };

export default BookingDetails;
